import { formatUsd, formatQuarterLabel } from '../installmentFormat'

export default function SelectInvoiceStep ({ invoices, selectedId, onSelect }) {
  if (!invoices.length) {
    return (
      <p className='text-sm text-slate-600 dark:text-slate-300'>There are no unpaid invoices eligible for payment installments.</p>
    )
  }

  return (
    <div className='flex flex-col gap-3'>
      <p className='text-sm text-slate-600 dark:text-slate-300'>Choose the invoice you want to set up a payment plan for. Each invoice is set up separately.</p>
      {invoices.map((invoice) => {
        const selected = invoice.invoiceId === selectedId
        return (
          <button
            key={invoice.invoiceId}
            type='button'
            onClick={() => onSelect(invoice)}
            className={`text-left rounded-2xl border p-4 transition-colors ${selected
              ? 'border-sky-600 bg-sky-50 dark:bg-sky-900/20'
              : 'border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800'}`}
          >
            <p className='text-sm font-bold text-slate-900 dark:text-white'>Invoice #{invoice.invoiceNumber || '—'} · {formatQuarterLabel(invoice.quarter)}</p>
            {invoice.invoiceDescription ? <p className='text-xs text-slate-500 mt-1'>{invoice.invoiceDescription}</p> : null}
            <p className='text-sm text-slate-600 dark:text-slate-300 mt-1'>{formatUsd(invoice.invoiceAmount)} · {invoice.invoiceStatus}</p>
          </button>
        )
      })}
    </div>
  )
}
